/** Vendored editor-runtime bundle synced into /public by `hero-app:sync-public`. */
const DEFAULT_HERO_RUNTIME_SCRIPT_PATH =
  "/soffi-editor-runtime/v0.7.0/editor-runtime.js";

/**
 * URL of the editor-runtime bundle injected into the hero iframe.
 *
 * Defaults to the vendored bundle above. For local runtime development point
 * `NEXT_PUBLIC_SOFFI_RUNTIME_URL` at the @soffi/editor-runtime dev server:
 *
 *   cd ../soffi-main/web/lib/editor-runtime && pnpm dev   # watch + serve :3099
 *   NEXT_PUBLIC_SOFFI_RUNTIME_URL=http://localhost:3099/dist/editor-runtime.js
 *
 * Edit runtime source -> esbuild rebuilds -> reload the hero -> new runtime.
 * Keep NEXT_PUBLIC_SOFFI_HERO_LIVE_CANVAS=false so the iframe stays on the
 * same-origin /soffi/hero-canvas route (which is what injects this script).
 * Port 3099 is already in the dev host-bus allowlist (runtime-scripts.tsx).
 */
export const HERO_RUNTIME_SCRIPT_PATH =
  process.env.NEXT_PUBLIC_SOFFI_RUNTIME_URL?.trim() ||
  DEFAULT_HERO_RUNTIME_SCRIPT_PATH;
